// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e14d1a68","239":"a410172d","634":"c4b3fb10"}[chunkId] + ".chunk.js";
};